import styled from 'styled-components';

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2.1875rem;
`;
